import apiConnector from '../api-connector'

const handlerFetch = async ({ queryKey: [_key, { version, userAgent, external } = {}, location], signal }) => {
  return await apiConnector({
    version,
    userAgent,
    location: location || _key,
    signal,
    external,
  })
}

export default handlerFetch
